<template>
    <div class="left-side-bar">
        <div class="block" v-for="(item,key) in bars" 
            :key="key"

        ><span class="div_title">{{item}}</span>
        </div>
    </div>
</template>

<script>
export default {
    name:'LeftSideBar',
    data(){
        return {
            bars:{'源':'因、根、类别、规律','流':'果、叶、特征、表象','和':''}
        }
    },
}
</script>

<style lang="stylus" scoped>
@import '~css/mixins.styl';
@import '~css/var.styl';
.left-side-bar
    width:10%
    min-width:50px
    border:1px solid rgba(0,0,0,0.2)
    justify-content:center
    display:flex
    align-items :center
    flex-direction :column
    box-sizing:border-box;
    transition:width 2s;

    & div:nth-child(1)
        height:$source_height
        box-sizing:border-box;
        background-color:$left_bar_1_color;
        background-image:url('~pic/源.png');
        background-repeat:no-repeat;
        background-position:center;
        
    & div:nth-child(2)
        height:$flow_height
        box-sizing:border-box;
        //background-color:$left_bar_2_color;
        //background-image:url('~pic/流.png');
        //background-repeat:no-repeat;
        //background-position:center;
        //background:linear-gradient($left_bar_1_color,$left_bar_3_color);
        background:url('~pic/流.png') center no-repeat,linear-gradient($left_bar_1_color,$left_bar_3_color);

    & div:nth-child(3)
        height:$total_height
        border:none;
        box-sizing:border-box;
        background-color:$left_bar_3_color;
        background-image:url('~pic/和.png');
        background-repeat:no-repeat;
        background-position:center;



.block
    border-bottom:1px solid rgba(0,0,0,.1);
    width:100%;
    position:relative;
    padding:10px 10px;
    font-size:35px;
    font-weight:100;
    box-sizing :border-box;
    center();
    //text-shadow:4px 4px 4px black;

    .div_title
        font-size:15px;
        position:absolute;
        bottom:1px;
 

</style>
